// Sugalarm — battery status hook (cycle 229).
//
// Returns { available, level, charging } for the header battery indicator.
// Fully inert (available:false, level:-1) off the Android kiosk APK — the
// `lib/battery` proxy is a no-op everywhere the native plugin isn't present
// (web, Pi kiosk, iPad, mobile, the `standard` flavor).

import { useEffect, useState } from "react";

import { getStatus, isAvailable, subscribe } from "../lib/battery";

export interface BatteryState {
  available: boolean;
  /** 0–100, or -1 when unknown/unavailable. */
  level: number;
  charging: boolean;
}

export function useBatteryStatus(): BatteryState {
  // `isAvailable()` is a synchronous bridge presence check — stable for the
  // lifetime of the surface, so it's a fine effect dependency.
  const available = isAvailable();
  const [level, setLevel] = useState(-1);
  const [charging, setCharging] = useState(false);

  useEffect(() => {
    if (!available) return;
    let active = true;
    // Seed once, then track live changes.
    void getStatus().then((s) => {
      if (active && s) {
        setLevel(s.level);
        setCharging(s.charging);
      }
    });
    const unsub = subscribe((s) => {
      setLevel(s.level);
      setCharging(s.charging);
    });
    return () => {
      active = false;
      unsub();
    };
  }, [available]);

  return { available, level, charging };
}
